<template>
	<component
		:is="tag"
		:class="[
			settings.fixedClasses,
			settings.sizes[size],
			settings.surfaceColors[color],
			settings.onSurfaceColors[color],
		]"
	>
		<slot />
	</component>
</template>

<script setup>
import {defineSettings} from '../composables/component';
const settings = defineSettings('NkBadge');

defineProps({
	tag: {
		type: String,
		default: 'span',
		required: false,
	},
	size: {
		type: String,
		default: 'sm',
		required: false,
	},
	color: {
		type: String,
		default: 'primary',
		required: false,
	},
});
</script>
